export const initialValues: { [key: string]: { [key: string]: string | [] } } = {
  '3': {
    '1': '',
    '2': '',
    '3': '',
    '4': '',
    '5': '',

    '6': '',
    '7': '',
    '8': '',
    '9': '',

    '10': '',
    '11': '',
    '12': '',
    '13': '',
    '14': [],
    '1411': '',
    '1421': '',
    '1431': '',
    '1441': '',

    '15': [],
    '1521': '',
    '1522': '',
    '1523': '',
    '1531': '',
    '1532': '',
    '1533': '',
    '1541': '',
    '1542': '',
    '1543': '',

    '16': '',
    '17': [],
    '18': '',
    '19': '',
    '20': '',

    '21': '',
    '2121': '',
    '2122': '',
    '2123': [],
  }
};
